import React from 'react';
import { Typography } from '@mui/material';
import { PayerInfoProps } from '../../types';

const PayerInfo: React.FC<PayerInfoProps> = ({ billingInfo }) => {
    return (
        <div className="payer-info">
            <Typography variant="h6">Payer Info</Typography>
            <Typography variant="body1">{billingInfo.firstName} {billingInfo.lastName}</Typography>
            <Typography variant="body1">{billingInfo.address}</Typography>
            <Typography variant="body1">{billingInfo.city}, {billingInfo.state}, {billingInfo.zipCode}</Typography>
        </div>
    );
};

export default PayerInfo;
